import React from 'react';
import { Link2 } from 'lucide-react';
import { getColors } from '../theme';
import { useApp } from '../context/AppContext';

/**
 * LinkHabitsPrompt - Empty state prompt shown when a goal has no linked habits
 * 
 * Features:
 * - Dashed circle outline with mint border
 * - "Link habits" text with link icon
 * - Hover effect: solid border, scale up
 * - Clicking triggers callback to open goal edit modal
 * 
 * @param {function} onClick - Click handler to open goal edit modal
 * @param {number} size - Size of the prompt circle (default: 64)
 * @param {string} className - Additional CSS classes
 */
const LinkHabitsPrompt = ({ onClick, size = 64, className = '' }) => {
  const { isDark } = useApp();
  const colors = getColors(isDark);
  
  // Determine text size based on container size
  const textSize = size < 40 ? '8px' : size < 60 ? '9px' : '10px';
  const iconSize = size < 40 ? 10 : size < 60 ? 12 : 14;
  const showText = size >= 50;
  
  return (
    <button
      onClick={onClick}
      className={`group relative inline-flex flex-col items-center justify-center rounded-full transition-all duration-200  ${className}`}
      style={{ 
        width: size, 
        height: size,
        border: `2px dashed ${colors.accent}40`,
        backgroundColor: 'transparent',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderStyle = 'solid';
        e.currentTarget.style.borderColor = colors.accent;
        e.currentTarget.style.backgroundColor = `${colors.accent}10`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderStyle = 'dashed';
        e.currentTarget.style.borderColor = `${colors.accent}40`;
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
      title="Link habits to this goal"
    >
      <Link2 
        size={iconSize} 
        style={{ color: colors.accent }}
        className="transition-transform group-hover:rotate-12"
      />
      {showText && (
        <span 
          className="mt-0.5 font-medium"
          style={{ 
            fontSize: textSize, 
            color: colors.accent,
            lineHeight: 1,
          }}
        >
          Link
        </span>
      )}
    </button>
  );
};

export default LinkHabitsPrompt;
